// Загрузка приложения
export const SET_APP_START = 'SET_APP_START';
// Состояние загрузки
export const LOADING = 'LOADING';
// Форма авторизации
export const AUTH_FORM = 'AUTH_FORM';
// Форма регистрации
export const REGISTRATION_FORM = 'REGISTRATION_FORM';
// Форма восстановления пароля
export const RECOVERY_PASSWORD_FORM = 'RECOVER_PASSWORD_FORM';
// Форма проверки кода из письма
export const CHECK_EMAIL_FORM = 'CHECK_EMAIL_FORM';
// Записи
export const BOOKING = 'BOOKING';
// Фильтры
export const FILTERS = 'FILTERS';
// Параметры заведения для iframe
export const EST = 'EST';
// Боковое меню пользователя
export const SET_USER_BAR = 'SET_USER_BAR';
// Данные пользователя
export const SET_USER = 'SET_USER';
// Абонементы пользователя
export const SET_SUBSCRIPTIONS = 'SET_SUBSCRIPTIONS';
// Расписание
export const SET_SCHEDULE = 'SET_SCHEDULE';
// Доступность расписания с услугами
export const SET_SCHEDULE_ACTIVE = 'SET_SCHEDULE_ACTIVE';
// Список записей на услуги
export const SET_MY_RESERVES = 'SET_MY_RESERVES';